class {
   onCreate(input, out) {
    this.state = {
     currentStep: input.step === "setup" ? 2 : 3
    };
  }
}

<style>
.steps{
    display: flex;
    padding: 33px 0px 50px 0px;
    justify-content: center;
    max-width: 550px;
    margin: 0 auto;
}
svg { 
  max-width: unset;
}
 .step_divider {
    height: 5px;
    width: 138px;
    background-color: #d8daf4;
    border-radius: 15px;
  }
  .step_divider_green {
    height: 5px;
    width: 138px;
    background-color: #4DB617;
    border-radius: 15px;
  }
  .step_first {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .step-text {
    text-align: center;
    color: black;
    font-weight: bold;
  }
   .step_part {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
   .svg-margin {
    margin-bottom: 15px;
  }
  .circle-current {
    width: 30px; /* Width of the circle */
    height: 30px; /* Height of the circle */
    color: white; /* Text color */
    background: #4DB617;
    font-size: 16px; /* Text size */
    font-weight: 500; /* Use numeric value for medium weight */
    display: flex; /* Use flexbox for centering */
    align-items: center; /* Center text vertically */
    justify-content: center; /* Center text horizontally */
    border-radius: 50%; /* Make the div a circle */
    text-align: center; /* Center-align the text */
    letter-spacing: 0; /* No extra spacing between letters */
  }
  .circle-next {
    width: 30px; /* Width of the circle */
    height: 30px; /* Height of the circle */
    color: #737590; /* Text color */
    background-color: white; /* Background color */
    font-size: 16px; /* Text size */
    font-weight: medium; /* Optional: Make text medium */
    display: flex; /* Use flexbox for centering */
    align-items: center; /* Center text vertically */
    justify-content: center; /* Center text horizontally */
    border-radius: 50%; /* Make the div a circle */
    text-align: center; /* Center-align the text */
    letter-spacing: 0; /* No extra spacing between letters */
    border: 2px solid #d8daf4; /* Add a border with the specified color */
  }
   @media (max-width: 768px) {
    .mob-margin-top{
        margin-bottom: 24px;
        }
         .step-text {
      display: none;
    }
    .divider {
    background: #e1e5ef; /* Adjust margin as needed */
    width: 1px;
  }
   
   .steps {
      gap: 10px;
      padding-left: 0px;
      padding: 10px 0px;
    }
    .step_divider_green {
    height: 3px;
    width: 195px;
    background-color: #4DB617;
    border-radius: 15px;
  }
   .step_divider {
    height: 3px;
    width: 195px;
  }
  .step_container{
    width: 50px;
    height:30px;
    }
   }
</style>

<div class="steps mob-margin-top">
  <div class="step_container">
    <div class="step_part">
      <if(state.currentStep > 1)>
        <svg width="30" height="30" class="svg-margin" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="15" fill="white"/>
          <path d="M15 0C6.72932 0 0 6.72932 0 15C0 23.2707 6.72932 30 15 30C23.2707 30 30 23.2707 30 15C30 6.72932 23.2707 0 15 0ZM23.3835 11.0526L13.797 20.5639C13.2331 21.1278 12.3308 21.1654 11.7293 20.6015L6.65414 15.9774C6.05263 15.4135 6.01504 14.4737 6.54135 13.8722C7.10526 13.2707 8.04511 13.2331 8.64662 13.797L12.6692 17.4812L21.2406 8.90977C21.8421 8.30827 22.782 8.30827 23.3835 8.90977C23.985 9.51128 23.985 10.4511 23.3835 11.0526Z" fill="#4DB617"/>
        </svg>
      </if>
      <else>
        <p class=`${state.currentStep == 1 ? "circle-current" : "circle-next"}`>1</p>
      </else>
      <p class="step-text">Select &nbsp; Plan</p>
    </div>
  </div>
  <div class=`mt-2 ${state.currentStep > 1 ? "step_divider_green" : "step_divider"}`/>
  <div class="step_container">
    <div class="step_part">
      <if(state.currentStep > 2)>
        <svg width="30" height="30" class="svg-margin" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="15" fill="white"/>
          <path d="M15 0C6.72932 0 0 6.72932 0 15C0 23.2707 6.72932 30 15 30C23.2707 30 30 23.2707 30 15C30 6.72932 23.2707 0 15 0ZM23.3835 11.0526L13.797 20.5639C13.2331 21.1278 12.3308 21.1654 11.7293 20.6015L6.65414 15.9774C6.05263 15.4135 6.01504 14.4737 6.54135 13.8722C7.10526 13.2707 8.04511 13.2331 8.64662 13.797L12.6692 17.4812L21.2406 8.90977C21.8421 8.30827 22.782 8.30827 23.3835 8.90977C23.985 9.51128 23.985 10.4511 23.3835 11.0526Z" fill="#4DB617"/>
        </svg>
      </if>
      <else>
        <p class=`${state.currentStep == 2 ? " circle-current" : " circle-next"}`>2</p>
      </else>
      <p class="step-text">Setup &nbsp; Username</p>
    </div>
  </div>
  <div class=` mt-2 ${state.currentStep > 2 ? "step_divider_green" : "step_divider"}`/>
  <div class="step_container">
    <div class="step_part">
      <if(state.currentStep > 3)>
        <svg width="30" height="30" class="svg-margin" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="15" fill="white"/>
          <path d="M15 0C6.72932 0 0 6.72932 0 15C0 23.2707 6.72932 30 15 30C23.2707 30 30 23.2707 30 15C30 6.72932 23.2707 0 15 0ZM23.3835 11.0526L13.797 20.5639C13.2331 21.1278 12.3308 21.1654 11.7293 20.6015L6.65414 15.9774C6.05263 15.4135 6.01504 14.4737 6.54135 13.8722C7.10526 13.2707 8.04511 13.2331 8.64662 13.797L12.6692 17.4812L21.2406 8.90977C21.8421 8.30827 22.782 8.30827 23.3835 8.90977C23.985 9.51128 23.985 10.4511 23.3835 11.0526Z" fill="#4DB617"/>
        </svg>
      </if>
      <else>
        <p class=`${state.currentStep == 3 ? " circle-current" : "  circle-next"}`>3</p>
      </else>
      <!-- </div> -->
      <p class="step-text">Get &nbsp; Started</p>
    </div>
  </div>
</div>
